import { DatePicker } from "antd";
import config from "rc-picker/lib/generate/dateFns";

export const CustomDatePicker = DatePicker.generatePicker<Date>(config);
